import React, { ReactNode, useState } from "react";
import "../CSS/FAQExpandableSection.css";
import collapsedArrowIcon from "../../../assets/images/profile-collapsed-arrow-icon.svg";

interface FAQExpandableSectionProps {
  title: string;
  children: ReactNode;
}

const FAQExpandableSection: React.FC<FAQExpandableSectionProps> = ({
  title,
  children,
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <div
      style={{ marginBottom: "10px" }}
      className={`${expanded && "faq-main-container"}`}
    >
      <div
        className={`faq-container ${expanded && "expanded"}`}
        onClick={() => setExpanded((prev) => !prev)}
        style={{ cursor: "pointer" }}
      >
        <div className="sub-conatiner">
          <span style={{color: `${expanded ? "#C2B58C" : "white"}`}}>{title}</span>
          <div className="faq-expand-container">
            <img
              src={collapsedArrowIcon}
              alt="collapsed-arrow-icon"
              style={{
                transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            />
          </div>
        </div>

        <div className="divider"></div>
      </div>
      {expanded && <div className="faq-content">{children}</div>}
    </div>
  );
};

export default FAQExpandableSection;
